export default (str: string): string => str.replace(/(\/)\1+/g, "$1")
